module.exports = __webpack_public_path__ + "static/media/askdarcel-user-research.2af7c368.jpg";